<template>
  <div id='box'>
     <!-- 头部组件 -->
    <header class='box'>
      <headers></headers>
    </header>
    <div class="form">
      <div class='content'>
        <header class='title'></header>
        <div class="step flex stars" v-if="school">
          <div class='step_item step_item1'>
            <img class='step_img' :src="img2" alt="">
            <div class='step_content flex_center'>
              <!-- <i class='iconfont icon-user-add'></i> -->
              <img class='icon-img' :src="register7" alt="">
              <span class='step_text'>用户注册</span>
            </div>
          </div>
          <!-- <div class='step_item step_item1'>
            <img class='step_img' :src="img2" alt="">
            <div class='step_content flex_center'> -->
              <!-- <i class='iconfont icon-HTyonghushenhe'></i> -->
              <!-- <img class='icon-img' :src="register6" alt="">
              <span class='step_text'>审核账号</span>
            </div>
          </div> -->
          <div class='step_item step_item1'>
            <img class='step_img' :src="img2" alt="">
            <div class='step_content flex_center'>
              <!-- <i class='iconfont icon-user-add'></i> -->
              <img class='icon-img' :src="register7" alt="">
              <span class='step_text'>注册成功</span>
            </div>
          </div>
        </div>
        <div class='forms' v-if="school">
          <div class='icon'>
            <img :src="img3" alt="">
          </div>
          <div class='tips' v-if="sync == '1'">恭喜您注册成功</div>
          <div class='tips' v-if="sync == '2'">正在审核中</div>
          <div class='tips' v-if="sync == '3'">恭喜您注册成功</div>
          <div class='tips1'>请仔细保管您的账号和密码</div>
          <div class='tips1' v-if="forsa == '1'">待代理机构审核通过前，您可以付费登记</div>
          <div class='tips1' v-if="forsa == '1'">待代理机构审核通过后，您可以免费登记</div>
          <div class='tips1' ><el-button type="primary" @click="copyright()" class='botton'>去登记</el-button></div>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      title="湖北省著作权登记系统用户协议和隐私政策"
      :visible.sync="dialogVisible"
      width="1076px"
      :before-close="handleClose">
      <div class='center'>用户协议</div>
      <div class='agreement_content'>
        <div class='time'>版本生效日期：2021年3月26日</div>
      </div>  
      <span slot="footer" class="flex_nav">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="dialogVisible = false">同意并继续</el-button>
      </span>
    </el-dialog> -->
    <!-- 尾部组件 -->
    <div class='box'>
      <tails></tails>
    </div>
  </div>
</template>

<script>
import headers from "@/components/header";
import tails from "@/components/tail";
import stepa from "@/assets/step_a.png";
import stepb from "@/assets/step_b.png";
import success from "@/assets/success.png";
import register1 from "@/assets/register1.png";
import register2 from "@/assets/register2.png";
import register3 from "@/assets/register3.png";
import register4 from "@/assets/register4.png";
import register5 from "@/assets/register5.png";
import register6 from "@/assets/register6.png";
import register7 from "@/assets/register7.png";
import register8 from "@/assets/register8.png";
import error from "@/assets/error.png";
import time from "@/assets/time.png";
export default {
  data() {
    return {
      dialogVisible:true,
      img1:stepa,
      img2:stepb,
      img3:success,
      register1,
      register2,
      register3,
      register4,
      register5,
      register6,
      register7,
      register8,
      error,
      time,
      school:true,
      /* form:{
        name:'',
        phone:'',
        verificationcode:'',
        password:'',
        repassword:'',
        Graphicverificationcode:'',
        school:''
      }, */
      Graphicverificationcode:'1234',
      code:4444,
      type:'',
      forsa:'3',
      userInfo:'',
      sync:'1',
      agreement:'',
    }
  },
  components:{
    headers,
    tails
  },
    mounted(){
      this.type = sessionStorage.getItem('checkStatus')
      this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"))
      // console.log(this.userInfo,"this.userInfo!!!")
      // console.log(this.type)
        if(this.type == '"0"' || this.type == "0"){
          this.forsa = '1'
        }else{
          this.forsa = '2'
        }
        // console.log(this.userInfo.checkStatus,'!1@')
        if(this.userInfo.checkStatus == "0" || this.userInfo.checkStatus == 0){
             this.sync = '2'
        }else  if(this.userInfo.checkStatus == "1" || this.userInfo.checkStatus == 1){
             this.sync = '1'
        }else if(this.userInfo.checkStatus == undefined){
           this.sync = '3'
        }
  },
  methods: {
    copyright(){
        this.$router.push('/copyright')
    },
    handleClose(done) {
      this.$confirm('确认取消注册吗？')
        .then(_ => {
          this.$router.push('/login')
        })
        .catch(_ => {});
    },
    onSubmit(formName) {
      // console.log('submit!');
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    getCode(){
      // console.log('code')
    }
  }
}
</script>

<style lang='less' scoped>
.stars{
  width: 800px;
    margin: 0 auto;
}
  #box{
    // position: absolute;
    // left: 0;
    // top: 0;
    // // width: 100%;
    // height: 100%;
    background: #f3f6f8;
  }
  .form{
    height: calc( 100% - 243px );
    min-height: 650px;
    background: #D2E0F6;
    .title{
      padding-top: 7px;
      padding-bottom: 32px;
      height: 0px;
      font-size: 26px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0px;
      letter-spacing: 0px;
      color: #333333;
    }
    .step_item{
      position: relative;
      height: 65px;
      .step_img{
        width: 100%;
        height: 100%;
      }
      .step_img1{
        opacity: 0.2;
      }
      .step_content{
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        font-size: 20px;
        img{
          width: 36px;
          height: 36px;
        }
        .iconfont{
          font-size: 20px;
        }
        .icon-HTyonghushenhe{
          font-size: 30px;
        }
      }
    }
    .step_item1{
      width: 400px;
    }
    .step_item2{
      width: 600px;
    }
    .forms{
      margin-top: 30px;
      height: 400px;
      background: #fff;
      border-radius: 10px;
      .icon{
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin: 0px auto ;
        padding: 40px 0 29px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .tips{
        height: 53px;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 18px;
        letter-spacing: 0px;
        color:  #0068b7;
        margin-bottom: 13px;
        text-align: center;
      }
      .tips1{
        height: 27px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 27px;
        letter-spacing: 0px;
        color: #333333;
        text-align: center;
      }
      .botton{
        width: 370px;
        height: 50px;
        background-color:  #0068b7;
        border-radius: 10px;
        margin: 0 auto;
	      font-size: 18px;
            margin-top: 40px;
      }
    }
  }
  .box{
    background: #f2f2f2;
  }
  .center{
    text-align: center;
    margin-bottom: 24px;
    height: 35px;
    font-size: 26px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 35px;
    letter-spacing: 0px;
    color: #333333;
  }
  .flex_nav{
    width: 600px;
    margin: 0 auto;
  }
  .agreement_content{
    width: 950px;
    margin: 0 auto;
    .time{
      height: 32px;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 32px;
      letter-spacing: 0px;
      color: #333333;
      margin-bottom: 32px;
    }
    .agreement{
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 32px;
      letter-spacing: 0px;
      color: #333333;
      height: 300px;
      overflow: auto;
    }
    .agreement::-webkit-scrollbar {    /*滚动条整体样式*/
      width: 10px;                        /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    .agreement::-webkit-scrollbar-thumb {  /*滚动条里面小方块*/
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      background: #ebebeb;
    }
    .agreement::-webkit-scrollbar-track {  /*滚动条里面轨道*/
      /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
      border-radius: 10px;
      background: #fff;
    }
  }
  .select{
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/view/examine.vue